// extracted by mini-css-extract-plugin
export default {"container":"DQoG9Z","padding":"JXRsRN","small":"rJrKsr","active":"fUsZOM"};